import { useState } from "react";
import ConfirmacionModal from "../../../Comunes/ConfirmacionModal/ConfirmacionModal";
import { Notificar } from "../../../Comunes/Notificador";
import servicioCambiosCic from "../../../../servicios/servicioCambiosCic";

function EliminarSolicitudModal({ solicitud, regresarAListaSolicitudes }) {
  const [mostrarModal, setMostrarModal] = useState(false);

  const eliminarSolicitud = async () => {
    const parametro = {
      solicitud: solicitud,
    };

    const resultado = await servicioCambiosCic.EliminarUnaSolicitudCambio(
      parametro
    );

    if (!resultado.esValido) {
      Notificar("error", resultado.errores);
      return;
    }

    setMostrarModal(false);

    regresarAListaSolicitudes({
      solicitud: solicitud,
      excluirSolicitudDeLaLista: true,
      mensaje: resultado.mensaje,
    });
  };

  return (
    <>
      <button
        className="btn btn-secondary btn-icon-split"
        onClick={() => setMostrarModal(true)}
      >
        <span className="icon text-white-50">
          <i className="fas fa-trash-alt"></i>
        </span>
        <span className="text">Eliminar</span>
      </button>

      <ConfirmacionModal
        isOpen={mostrarModal}
        onClose={() => setMostrarModal(false)}
        onConfirm={eliminarSolicitud}
        mensaje="¿Está seguro que desea eliminar esta solicitud?"
      />
    </>
  );
}

export default EliminarSolicitudModal;
